import React from 'react';

function GeneralManagerMenu(props) {
    return (
        <ul id="navbarSettings" className="navbar-nav nav nav-vertical nav-tabs nav-tabs-borderless nav-sm">
            <li className="nav-item">
                <span className="nav-subtitle">Menu</span>
            </li>
            <li className="nav-item ">
                <a className="nav-link dropdown-toggle" href="#dashboardSidebar" role="button"
                   data-bs-toggle="collapse" aria-expanded="false"
                   aria-controls="dashboardSidebar">Tableau de bord</a>

                <div id="dashboardSidebar" className="nav-collapse collapse ">
                    <a className="nav-link" href="cards-grid.html">KPIs stratégiques</a>
                    <a className="nav-link" href="cards-list.html">Analyse SWOT</a>
                </div>
            </li>
            <li className="nav-item ">
                <a className="nav-link dropdown-toggle" href="#teamManagementSidebar" role="button"
                   data-bs-toggle="collapse" aria-expanded="false"
                   aria-controls="teamManagementSidebar">Gestion des équipes et projets</a>

                <div id="teamManagementSidebar" className="nav-collapse collapse ">
                    <a className="nav-link" href="cards-grid.html">Projets</a>
                    <a className="nav-link" href="cards-list.html">Performances équipes</a>
                </div>
            </li>
            <li className="nav-item ">
                <a className="nav-link dropdown-toggle" href="#performSidebar" role="button"
                   data-bs-toggle="collapse" aria-expanded="false"
                   aria-controls="performSidebar">Analyse des performances</a>

                <div id="performSidebar" className="nav-collapse collapse ">
                    <a className="nav-link" href="cards-grid.html">Graphique trimestriels et annuels</a>
                    <a className="nav-link" href="cards-list.html">Comparaisons historiques</a>
                </div>
            </li>
            <li className="nav-item ">
                <a className="nav-link dropdown-toggle" href="#financialSidebar" role="button"
                   data-bs-toggle="collapse" aria-expanded="false"
                   aria-controls="financialSidebar">Rapports financiers</a>

                <div id="financialSidebar" className="nav-collapse collapse ">
                    <a className="nav-link" href="cards-grid.html">Etats financiers</a>
                    <a className="nav-link" href="cards-list.html">Flux de trésorerie et bilans</a>
                </div>
            </li>
        </ul>
    );
}

export default GeneralManagerMenu;